<template>
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" clearable placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.bill_lading_no" clearable placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.container_no" clearable placeholder="货柜号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.bale_no" clearable placeholder="捆包号"></el-input>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.brand_id" clearable placeholder="品牌" @visible-change="getBrandList">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.breed_id" clearable placeholder="品名" @visible-change="getBreedList">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.grade_id" clearable placeholder="等级" @visible-change="getGradeList">
                    <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.search.foreign_currency_id" clearable placeholder="外币名称" @visible-change="getCurrencyList">
                  <el-option v-for="list in currencyList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.search.warehouse_id" clearable placeholder="仓库" @visible-change="getPurchaseWareList">
                  <el-option v-for="list in getPurchaseWarehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.thickness" clearable placeholder="厚度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.length" clearable placeholder="长度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.width_total" clearable placeholder="宽度"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" clearable v-if="isShowMore" v-model="params.search.traffic_type" placeholder="单据类型">
                    <el-option :value="1" :label="'入库记录'"></el-option>
                    <el-option :value="2" :label="'出库记录'"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="search">查询</el-button>
                    <div class="reset fcolor" style="margin: 0 20px;">
                        <el-checkbox v-model="is_like">精确查找</el-checkbox>
                    </div>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.bale_no" placeholder="捆包号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.bill_lading_no" placeholder="提单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.storage_age" placeholder="库龄" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.storage_location" placeholder="库位" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.remark" placeholder="备注" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="search">查询</el-button>
                </div> -->
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="report.purchase.in.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" ></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">件数:{{ statistics.count }}件</div>
                <div class="totalNumber">方数：{{ statistics.cube }}m³</div>
                <div class="totalNumber">采购金额：{{ statistics.amount }}</div>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="report.purchase.in.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
        </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: "",
                customerList : [],
                saleManList : [],
                params : {
                    page : 1,
                    per_page : 50,
                    search : {
                        start_time : "",
                        end_time : "",
                        contract_no:"",
                        bill_lading_no:"",
                        container_no:"",
                        bale_no:"",
                        breed_id:"",
                        brand_id : "",
                        grade_id:"",
                        foreign_currency_id:"",
                        thickness:"",
                        length:"",
                        width_total : "",
                        traffic_type:"",
                        warehouse_id:"",
                    }
                },
                is_like:false,
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count : 0,
                    cube : 0,
                },
                brandList : [],
                breedList : [],
                gradeList : [],
                currencyList:[],
                getPurchaseWarehouseList:[],
                list:[],
                tableCol:[
                    {colName:"资源状态",colKey:"status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"锁定人",colKey:"locker_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售单价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币采购单价",colKey:"foreign_currency_price",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币名称",colKey:"foreign_currency_name",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"人民币采购单价",colKey:"cube_price",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"目的港",colKey:"purpose_port",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出入库时间",colKey:"inbound_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库人",colKey:"stocker_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计入库",colKey:"expected_storage_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计到港",colKey:"expected_arrival_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                // change
                isShowMore :false,
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                isShowMore:false,
                troll:{},
            }
        },
        created() {
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = new Date();
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.search();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.purchase.in.list","板材采购入库明细",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.troll = this.$deepClone(this.params);
                if(this.is_like){
                    this.troll.search.thickness_jq = this.params.search.thickness;
                    this.troll.search.length_jq = this.params.search.length;
                    this.troll.search.width_total_jq = this.params.search.width_total;
                    delete this.troll.search.thickness;
                    delete this.troll.search.length;
                    delete this.troll.search.width_total;
                }else{
                    delete this.troll.search.thickness_jq;
                    delete this.troll.search.length_jq;
                    delete this.troll.search.width_total_jq;
                }
                this.$postColumnList("/erp/report.purchase.in.list",this.troll,response=>{
                    if(response.data.code == 0){
                        let list = response.data.data.list
                        list.forEach((item,index) => {
                            if(list[index].expected_storage_time!=0){
                                list[index].expected_storage_time = this.formatTime(list[index].expected_storage_time+"000")
                            }else{
                                list[index].expected_storage_time = "";
                            }
                            if(list[index].expected_arrival_time!=0){
                                list[index].expected_arrival_time = this.formatTime(list[index].expected_arrival_time+"000")
                            }else{
                                list[index].expected_arrival_time = "";
                            }
                            if(list[index].inbound_time!=0){
                                list[index].inbound_time = this.formatTime(list[index].inbound_time+"000")
                            }else{
                                list[index].inbound_time = "";
                            }
                            // item.expected_storage_time =  window.moment( Number(item.expected_storage_time) * 1000 ).format("YYYY-MM-DD")
                            // item.expected_arrival_time =  window.moment( Number(item.expected_arrival_time) * 1000 ).format("YYYY-MM-DD")
                        })
                        this.list = list;
                        this.total = parseInt(response.data.data.total);
                        this.statistics = response.data.data.statistics;
                        this.last_page = parseInt(response.data.data.last_page);
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.filter = response.data.data.column;
                        this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                            if(item.colKey=="status_str"){
                                if(this.fields.indexOf(",status,")!=-1){
                                    item.isShow=true;
                                }
                            }
                        })
                    }
                })
            },
            search(){
                this.params.search.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            // reset(){
            //     this.start_time = "";
            //     this.end_time = "";
            //     this.params.search = {
            //         start_time : "",
            //         end_time : "",
            //         contract_no : "",
            //         bill_lading_no : "",
            //         bale_no : "",
            //         breed_id : "",
            //         brand_id : "",
            //         grade_id : "",
            //         thickness : "",
            //         length : "",
            //         width_total : "",
            //     }
            // },
            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList(this.params.search.salesman_id).then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },
            // 获取销售员
            getSalemanList(visible){
                if(visible){
                    this.$getSalemanList(this.params.search.customer_id).then(res=>{
                        this.saleManList = res.data.data;
                    })
                }
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },
            // 等级
            getCurrencyList(visible){
                if(visible){
                    this.$getCurrencyList().then(res=>{
                        this.currencyList = res.data.data;
                    })
                }
            },
            getPurchaseWareList(visible){
                if(visible){
                    this.$getPurchaseWareList().then(res=>{
                        this.getPurchaseWarehouseList = res.data.data;
                    })
                }
            },
            // change
            reset(){
                this.start_time = this.$getCurrentMonthStartValueOf();
                this.end_time = new Date();
                this.params.search.start_time = "";
                this.params.search.end_time = "";
                this.params.search.contract_no = "";
                this.params.search.bill_lading_no = "";
                this.params.search.container_no = "";
                this.params.search.bale_no = "";
                this.params.search.breed_id = "";
                this.params.search.brand_id = "";
                this.params.search.grade_id = "";
                this.params.search.foreign_currency_id = "";
                this.params.search.thickness = "";
                this.params.search.length = "";
                this.params.search.width_total = "";
                this.params.search.warehouse_id = "";
                this.search();
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params.search).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
